// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1k6yU","banner":"Footer_banner__3vnkY"};